export const locationCookie = 'location';

export const deviceIdName = 'lmrvid';

export const defaultCmsParser = 'butter';

export const defaultContactNumber = '877-641-8052';
